<template>
  <!-- <DateCircle :date="selectedDate" :is-blue="true" /> -->
  <div class="calendar-header">
    <div style="min-width: 48px"></div>
  </div>
  <div id="calendar-box">
    <div id="time-sheet">
      <div class="ec-calendar-gutter"></div>
      <div v-for="(time, index) in timeslots" :key="index" class="ec-time">
        {{ time }}
      </div>
    </div>
    <div class="ec-days">
      <div id="time-row-buffer" class="ec-lines">
        <div class="ec-calendar-gutter"></div>
        <div v-for="(line, index) in lines" :key="index" class="ec-line"></div>
      </div>
      <SalonResource
        v-for="(selected, resource, index) in resourceList"
        :key="index"
        :date="selectedDate"
        :resource="resource"
        :selected-resource="resourceList[resource]"
        :resource-appt="resource_appts[resource]"
      />
    </div>
  </div>
  <div id="calendar-gutter"></div>
</template>

<script setup>
import { times, scheduleEvents, distributeOnDateTime } from "./../../libs/util";
import { resourcesList } from "./../../libs/options";
import { useAppointmentStore } from "../../stores/appointmentsStore";
import { useDateStore } from "../../stores/datestore";
import {
  computed,
  inject,
  provide,
  watch,
  ref,
  watchEffect,
  onMounted,
  reactive,
} from "vue";

import SalonResource from "./SalonResource.vue";
let slotMinTime = "08:00:00";
let slotMaxTime = "21:00:00";
let slotDuration = "00:15:00";
let lines = [];
let timeslots = times(slotMinTime, slotMaxTime, slotDuration);
lines.length = timeslots.length;
const events = inject("events");
const apptStore = useAppointmentStore();
const selectedDate = inject("selectedDate");
const dateStore = useDateStore();
const resourceList = ref({});
const savedResources = ref({});
provide("resourceList", resourceList);

const dbstring = computed(() => {
  return dateStore.selectedDate
    .toLocaleString("en-GB", { timeZone: "UTC" })
    .split(",")[0];
});

watch(
  [() => apptStore.markedStylists, () => dateStore.selectedDate],
  () => {
    let marked_stylists = apptStore.markedStylists[dbstring.value];
    savedResources.value = marked_stylists !== undefined ? marked_stylists : [];
    resourceList.value = resourcesList.reduce((acc, resource) => {
      acc[resource] =
        savedResources.value[resource] !== undefined
          ? savedResources.value[resource]
          : null;
      return acc;
    }, {});
  },
  { immediate: true }
);

const viewState = {};
viewState["currentEvents"] = computed(function () {
  let current_date = new Date(selectedDate.value);
  return events.getEvents.filter((event) => {
    const eventUTCDate = event.datetime.toISOString().split("T")[0];
    const currentUTCDate = current_date.toISOString().split("T")[0];
    return eventUTCDate === currentUTCDate;
  });
});

provide("viewState", viewState);
const resource_appts = ref({});

watchEffect(() => {
  const _events = events.getEvents;
  const resourceEvents = {};
  const stylistColumns = [];
  const stylist_column_ids = [];

  for (let key in resourceList.value) {
    if (resourceList.value[key] !== null) {
      const stylistId = resourceList.value[key].id;
      const stylistEvents = _events.filter(
        (event) => event.stylist === stylistId
      );
      resourceEvents[key] = distributeOnDateTime(stylistEvents);
    } else {
      stylistColumns[key] = [];
      stylist_column_ids.push(key);
    }
  }
  const filtered_events = _events.filter((event) => event.stylist === null);
  const calendar_appts = scheduleEvents(filtered_events, stylist_column_ids);
  stylist_column_ids.forEach((columnId) => {
    resourceEvents[columnId] = calendar_appts[columnId];
  });
  resource_appts.value = resourceEvents;
});

window.addEventListener("scroll", function () {
  let dropDownInputs = document.querySelectorAll(".dropdown-input");
  let overFlow = document.getElementById("overFlowBox");
  let nodeList = Array.from(dropDownInputs);
  nodeList.push(overFlow);

  if (this.window.scrollY > 18) {
    nodeList.forEach((dropdown) => {
      if (!dropdown.classList.contains("sticky")) {
        dropdown.classList.toggle("sticky");
      }
    });
  } else {
    nodeList.forEach((dropdown) => {
      dropdown.classList.remove("sticky");
    });
  }
});

onMounted(() => {
  document
    .getElementById("calendar-boxed")
    .addEventListener("scroll", (event) => {
      let dropDownInputs = document.querySelectorAll(".dropdown-input");
      let overFlow = document.getElementById("overFlowBox");
      let nodeList = Array.from(dropDownInputs);
      nodeList.push(overFlow);
      if (event.currentTarget.scrollTop > 1) {
        nodeList.forEach((dropdown) => {
          if (!dropdown.classList.contains("sticky")) {
            dropdown.classList.toggle("sticky");
          }
        });
      } else {
        nodeList.forEach((dropdown) => {
          dropdown.classList.remove("sticky");
        });
      }
    });
});
</script>

<style>
.ec-time {
  font-size: 11px;
  height: 50px;
  top: -6px;
  position: relative;
  width: 40px;
  text-align: right;
}

#time-row-buffer {
  min-width: 10px;
  background-color: white;
}
#time-row-buffer > div {
  height: 50px;
}
#time-sheet div:nth-child(4n + 1) {
  font-weight: bold;
  font-size: 12px;
}

.ec-line::after {
  content: "";
  border-bottom: 1px solid lightgray;
  position: absolute;
  width: 100%;
}

.ec-days {
  position: relative;
  width: 100%;
  display: flex;
}
.calendar-header {
  display: flex;
}

.resource-label {
  width: 100%;
  align-content: center;
}

.ec-calendar-gutter {
  height: 50px;
}

#calendar-gutter {
  height: 40px;
  background-color: #fafafa;
  border: 1px solid #d3d3d3;
}

.sticky {
  position: fixed;
  top: 63px;
  z-index: 99;
  background-color: #fafafa !important;
  box-shadow: 0px 0px 2px lightgray;
}
</style>
